// extracted by mini-css-extract-plugin
export default {"subheader":"Subheader_subheader__TExCz","socialMedia":"Subheader_socialMedia__RXjKK","scrolled":"Subheader_scrolled__E4gJX"};